// import React, { useEffect, useState } from "react";
// import { getAllGiftcard, getSelectedGiftCard } from "../../actions/auth";
// import { Link } from "react-router-dom";
// import CardViewModal from "./CardViewModal";
// import { selectValueGetter } from "../../utils/helper";
// import { ValidatorForm } from 'react-form-validator-core';
// import SelectValidator from "../partial/SelectValidator";
// import TextValidator from "../partial/TextValidator";
// import AdminHeader from "../layout/AdminHeader";

// const AllGiftCard = () => {
//     const [datas, setDatas] = useState([]);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedOrg, setSelectedOrg] = useState("");
//     const [orgNames, setOrgNames] = useState([]);
//     const [state, setState] = useState({
//         showModal: false,
//         code: "",
//     });

//     const [options] = useState([
//         { label: 'All Gift Card', value: 'all' },
//         { label: 'Selected Gift Card', value: 'selected' },
//     ]);
//     const [isSelected, setIsSelected] = useState([]);
//     const [selectPurpose, setSelectPurpose] = useState("VENVA6DCERYE");
//     const [responseData, setResponseData] = useState([]);
//     const [purposeData, setPurposeData] = useState([]);
//     const [viewMode, setViewMode] = useState("all");
//     const { showModal, code } = state;
//     const [loader, setLoader] = useState(false);
//     const [filteredData, setFilteredData] = useState([]);

//     const fetch = async () => {
//         let temp = [];
//         let temp1 = [];
//         let orgNames = new Set();
//         setLoader(true);
//         try {
//             let res = await getAllGiftcard();
//             setDatas(res.data)
//             res?.data?.forEach((item) => {
//                 if (item.default_vendor_code === 'VENVA6DCERYE' || item.default_vendor_code === 'VENKAWZ8CDUB') {
//                     temp.push({ label: item.default_vendor_code === 'VENVA6DCERYE' ? 'QwikCilver' : 'Razorpay GC', value: item.default_vendor_code });
//                 }
//                 if (item.org_name && !orgNames.has(item.org_name)) {
//                     orgNames.add(item.org_name);
//                     temp1.push({ label: item.org_name, value: item.org_name });
//                 }
//             });

//             let uniquePurposeData = Array.from(new Set(temp.map(JSON.stringify))).map(JSON.parse);
//             setPurposeData(uniquePurposeData);

//             let filteredData = res.data.filter(item => item.default_vendor_code === selectPurpose);
//             setResponseData(filteredData);
//             setFilteredData(filteredData);

//             setOrgNames(temp1);

//             setLoader(false);
//         } catch (error) {
//             setLoader(false);
//         }
//     };

//     useEffect(() => {
//         fetch();
//     }, []);

//     const handleViewModal = (item) => {
//         setState((prevState) => ({
//             ...prevState,
//             showModal: true,
//             code: item,
//         }));
//     };

//     const toggleSelectGiftCard = (id) => {
//         setIsSelected((prevSelected) => {
//             const exists = prevSelected.some(item => item.id === id);
//             if (exists) {
//                 return prevSelected.filter(item => item.id !== id);
//             } else {
//                 return [...prevSelected, { id, vendor_code: selectPurpose }];
//             }
//         });
//     };

//     const handleSelect = async (selectedOption) => {
//         setSelectedOrg("");
//         setViewMode("all");
//         setSelectPurpose(selectedOption.value);
//         setLoader(true);
//         try {
//             let filteredData = datas.filter(item => item.default_vendor_code === selectedOption.value);
//             setResponseData(filteredData);
//             setFilteredData(filteredData);
//             setLoader(false);
//         } catch (error) {
//             setLoader(false);
//         }
//     };

//     const handleView = (e) => {
//         setViewMode(e.value);
//     };

//     const fetchSelectedGiftCard = async () => {
//         setLoader(true);
//         try {
//             let response = await getSelectedGiftCard(localStorage.getItem("merchantId"));
//             let temp = [];
//             response?.data?.map((res) => {
//                 res.giftcard_code.map((giftcard) => {
//                     temp.push({
//                         ...giftcard,
//                         id: giftcard.id,
//                     });
//                     return temp;
//                 });
//                 setIsSelected(temp);
//             });
//         } catch (error) { }
//     };

//     const handleSelectOrg = async (e) => {
//         setSelectedOrg(e.value);
//         setLoader(true);
//         try {
//             let filteredData = datas.filter(item => item.org_name === e.value);
//             setResponseData(filteredData);
//             setFilteredData(filteredData);
//             setLoader(false);
//         } catch (error) {
//             setLoader(false);
//         }
//     };

//     useEffect(() => {
//         fetchSelectedGiftCard();
//     }, []);

//     const onSubmit = () => { };

//     const handleChange = (e) => {
//         const temp = e.target.value.toLowerCase();
//         setSearchTerm(temp);
//         if (temp) {
//             const tempData = responseData.filter((item) => item.title.toLowerCase().includes(temp));
//             setFilteredData(tempData);
//         } else {
//             setFilteredData(responseData);
//         }
//     };

//     return (
//         <>
//             <AdminHeader name={"Gift Card"} />
//             {loader && (
//                 <div className="mainPreloaderMain">
//                     <div className="mainPreloader">
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                     </div>
//                 </div>
//             )}
//             <div className="dashboard__content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="dashboard__customersCard">
//                             <div className="dashboard__body">
//                                 <div className="reseller_home__body__filter__right">

//                                 </div>
//                                 <ValidatorForm className="signUpPage__formSection" onSubmit={onSubmit}>
//                                     <div className="row">
//                                         <div className="col-md-9">
//                                             <div className="row">
//                                                 <div className="form-group col-md-4">
//                                                 <label> Vendor</label>
//                                                 <SelectValidator
//                                                     options={purposeData}
//                                                     onChange={handleSelect}
//                                                     value={selectValueGetter(purposeData, selectPurpose)}
//                                                 />
//                                             </div>
//                                             {selectPurpose === "VENKAWZ8CDUB" ?
//                                                 <div className="form-group col-md-4">
//                                                     <label>Organization</label>
//                                                     <SelectValidator
//                                                         options={orgNames}
//                                                         onChange={handleSelectOrg}
//                                                         value={selectValueGetter(orgNames, selectedOrg)}
//                                                     />
//                                                 </div>
//                                                 : <div className="form-group col-md-4"></div>}
//                                                     <div className="form-group col-md-4">
//                                                     <label>View Type</label>
//                                                     <SelectValidator
//                                                         options={options}
//                                                         onChange={handleView}
//                                                         value={selectValueGetter(options, viewMode)}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="form-group col-md-3">
//                                             <label>Search Gift Card</label>
//                                             <TextValidator type="text" value={searchTerm} placeholder="Search Gift Cards" onChange={handleChange} className="reseller_search"/>
//                                         </div>

//                                     </div>
//                                 </ValidatorForm>
//                                 <div className="all_giftcard_row">
//                                     {filteredData.length > 0 ? (
//                                         filteredData
//                                             .filter(item => viewMode === "all" || isSelected.some(selected => selected.id === item.id))
//                                             .map((item) => (
//                                                 <div key={item.id} className="all_giftcard_box">
//                                                     <div className="gc_imagebox">
//                                                         <img src={item?.image} alt="" />
//                                                         <div className="gc_overlay">
//                                                             <div className="gc_overlay_box">
//                                                                 <ul>
//                                                                     <li>
//                                                                         <Link to="" onClick={() => handleViewModal(item)}>
//                                                                             View Details
//                                                                         </Link>
//                                                                     </li>
//                                                                     <li>
//                                                                         <Link to="" onClick={() => toggleSelectGiftCard(item.id)}>
//                                                                             {isSelected.some(selected => selected.id === item.id) ? "Unselect" : "Select"}
//                                                                         </Link>
//                                                                     </li>
//                                                                 </ul>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row giftcard_voucher_details" style={{
//                                                         backgroundColor: isSelected.some(selected => selected.id === item.id) ? "#2056a5" : "#e3f2fd",
//                                                     }}>
//                                                         <div className="giftcard_voucher_title">
//                                                             <h5 style={{ color: isSelected.some(selected => selected.id === item.id) ? "white" : "#000" }}>{item?.title}</h5>
//                                                         </div>
//                                                     </div>
//                                                     {
//                                                         isSelected.some(selected => selected.id === item.id) ?
//                                                             <span><i className="fa-solid fa-circle-check"></i></span> : null
//                                                     }
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <p>No gift cards found.</p>
//                                     )}
//                                 </div>
//                                 <div className="row" style={{ paddingBottom: "20px" }}>
//                                     <div className="col-sm-12  col-md-12 col-lg-12 col-xl-12">
//                                         <div className="button-section" style={{ display: "flex", justifyContent: "flex-end" }}>
//                                             <Link to="/admin/gift-card-update" state={{ datas: isSelected, selectPurpose: selectPurpose }} type="submit" className="btn btn-primary" >
//                                                 Update
//                                             </Link>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             {showModal && (
//                                 <CardViewModal
//                                     show={showModal}
//                                     close={() => setState((prev) => ({ ...prev, showModal: false }))}
//                                     code={code}
//                                 />
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default AllGiftCard;

import React, { useEffect, useState } from 'react';
import {
	fetchVendorDetails,
	getAllGiftcard,
	getGiftcards,
	getSelectedGiftCard,
} from '../../actions/auth';
import { Link } from 'react-router-dom';
import CardViewModal from './CardViewModal';
import { selectValueGetter, VENDOR_LABEL_MAP } from '../../utils/helper';
import { ValidatorForm } from 'react-form-validator-core';
import SelectValidator from '../partial/SelectValidator';
import TextValidator from '../partial/TextValidator';
import AdminHeader from '../layout/AdminHeader';
import { useDispatch } from 'react-redux';
import { decrypt, encrypt } from '../../utils/encodingdecoding';

const AllGiftCard = () => {
	const [datas, setDatas] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [selectedOrg, setSelectedOrg] = useState('');
	const [state, setState] = useState({
		showModal: false,
		code: '',
	});

	const [options] = useState([
		{ label: 'All Gift Card', value: 'all' },
		{ label: 'Selected Gift Card', value: 'selected' },
	]);
	const [isSelected, setIsSelected] = useState([]);
	const [selectPurpose, setSelectPurpose] = useState('VENVA6DCERYE');
	const [responseData, setResponseData] = useState([]);
	const [purposeData, setPurposeData] = useState([]);
	const [viewMode, setViewMode] = useState('all');
	const { showModal, code } = state;
	const [loader, setLoader] = useState(false);
	const [filteredData, setFilteredData] = useState([]);
	const dispatch = useDispatch();
	const clientID = (() => {
		try {
			const venClientCode = sessionStorage.getItem('venClientCode');
			return venClientCode ? decrypt(venClientCode) : '';
		} catch {
			return '';
		}
	})();



	const fetchData = async () => {
		setLoader(true);

		try {
			const [venRes, res] = await Promise.all([
				dispatch(fetchVendorDetails()),
				dispatch(getGiftcards({ status: 1 })),
			]);

			if (venRes.data.errors === null) {
				sessionStorage.setItem(
					'venClientCode',
					encrypt(venRes.data.merchantClientId),
				);
			}

			const data = res?.data ?? [];
			setDatas(data);

			const purposeMap = new Map();
			const selectedItems = [];

			data.forEach((item) => {
				const { default_vendor_code, client_details } = item;

				// Purpose data
				const label = VENDOR_LABEL_MAP[default_vendor_code];
				if (label && !purposeMap.has(default_vendor_code)) {
					purposeMap.set(default_vendor_code, {
						label,
						value: default_vendor_code,
					});
				}

				// Selected data
				if (client_details && venRes.data.merchantClientId && venRes.data.merchantClientId in client_details) {
					selectedItems.push({
						id: item.id,
						vendor_code: item.default_vendor_code,
						status: client_details[venRes.data.merchantClientId]?.status,
						discount: client_details[venRes.data.merchantClientId]?.discount,
					});
				}
			});

			const filteredData = selectPurpose
				? data.filter(
						(item) => item.default_vendor_code === selectPurpose,
				  )
				: data;
			setPurposeData([...purposeMap.values()]);
			setIsSelected(selectedItems);
			setResponseData(filteredData);
			setFilteredData(filteredData);
		} catch (error) {
			console.error('Error fetching giftcards:', error);
		} finally {
			setLoader(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	const handleViewModal = (item) => {
		setState((prevState) => ({
			...prevState,
			showModal: true,
			code: item,
		}));
	};

	const toggleSelectGiftCard = (item) => {
		setIsSelected((prevSelected) => {
			const existingItem = prevSelected.find(
				(selected) => selected.id === item.id,
			);

			// If item exists → toggle status
			if (existingItem) {
				return prevSelected.map((selected) =>
					selected.id === item.id
						? {
								...selected,
								status: selected.status === 1 ? 0 : 1,
								discount: 0,
						  }
						: selected,
				);
			}

			// If item does not exist → add
			const hasClientInfo = Boolean(item.client_details?.[clientID]);

			return [
				...prevSelected,
				{
					id: item.id,
					vendor_code: item.default_vendor_code,
					status: hasClientInfo ? 0 : 1,
					discount: 0,
				},
			];
		});
	};

	const handleSelect = async (selectedOption) => {
		setSelectedOrg('');
		setViewMode('all');
		setSelectPurpose(selectedOption.value);
		setLoader(true);
		try {
			let filteredData = datas.filter(
				(item) => item.default_vendor_code === selectedOption.value,
			);
			setResponseData(filteredData);
			setFilteredData(filteredData);
			setLoader(false);
		} catch (error) {
			setLoader(false);
		}
	};

	const handleView = (e) => {
		setViewMode(e.value);
	};

	// const fetchSelectedGiftCard = async () => {
	// 	setLoader(true);
	// 	try {
	// 		let response = await getSelectedGiftCard(
	// 			localStorage.getItem('merchantId'),
	// 		);
	// 		let temp = [];
	// 		response?.data?.map((res) => {
	// 			res.giftcard_code.map((giftcard) => {
	// 				temp.push({
	// 					...giftcard,
	// 					id: giftcard.id,
	// 				});
	// 				return temp;
	// 			});
	// 			setIsSelected(temp);
	// 		});
	// 	} catch (error) {}
	// };

	// useEffect(() => {
	// 	fetchSelectedGiftCard();
	// }, []);

	const onSubmit = () => {};

	const handleChange = (e) => {
		const temp = e.target.value.toLowerCase();
		setSearchTerm(temp);
		if (temp) {
			const tempData = responseData.filter((item) =>
				item.title.toLowerCase().includes(temp),
			);
			setFilteredData(tempData);
		} else {
			setFilteredData(responseData);
		}
	};

	return (
		<>
			<AdminHeader name={'Gift Card'} />
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='dashboard__content'>
				<div className='container-fluid'>
					<div className='row'>
						<div className='dashboard__customersCard'>
							<div className='dashboard__body'>
								<div className='reseller_home__body__filter__right'></div>
								<ValidatorForm
									className='signUpPage__formSection'
									onSubmit={onSubmit}>
									<div className='row'>
										<div className='col-md-9'>
											<div className='row'>
												<div className='form-group col-md-4'>
													<label> Vendor</label>
													<SelectValidator
														options={purposeData}
														onChange={handleSelect}
														value={selectValueGetter(
															purposeData,
															selectPurpose,
														)}
													/>
												</div>
												<div className='form-group col-md-4'>
													<label>View Type</label>
													<SelectValidator
														options={options}
														onChange={handleView}
														value={selectValueGetter(
															options,
															viewMode,
														)}
													/>
												</div>
											</div>
										</div>
										<div className='form-group col-md-3'>
											<label>Search Gift Card</label>
											<TextValidator
												type='text'
												value={searchTerm}
												placeholder='Search Gift Cards'
												onChange={handleChange}
												className='reseller_search'
											/>
										</div>
									</div>
								</ValidatorForm>
								<div className='all_giftcard_row'>
									{filteredData.length > 0 ? (
										filteredData
											.filter(
												(item) =>
													viewMode === 'all' ||
													isSelected.some(
														(selected) =>
															selected.id ===
																item.id &&
															selected.status,
													),
											)
											.map((item) => (
												<div
													key={item.id}
													className='all_giftcard_box'>
													<div className='gc_imagebox'>
														<img
															src={item?.image}
															alt=''
														/>
														<div className='gc_overlay'>
															<div className='gc_overlay_box'>
																<ul>
																	<li>
																		<Link
																			to=''
																			onClick={() =>
																				handleViewModal(
																					item,
																				)
																			}>
																			View
																			Details
																		</Link>
																	</li>
																	<li>
																		<Link
																			to=''
																			onClick={() =>
																				toggleSelectGiftCard(
																					item,
																				)
																			}>
																			{isSelected.some(
																				(
																					selected,
																				) =>
																					selected.id ===
																						item.id &&
																					selected.status,
																			)
																				? 'Unselect'
																				: 'Select'}
																		</Link>
																	</li>
																</ul>
															</div>
														</div>
													</div>
													<div
														className='row giftcard_voucher_details'
														style={{
															backgroundColor:
																isSelected.some(
																	(
																		selected,
																	) =>
																		selected.id ===
																			item.id &&
																		selected.status,
																)
																	? '#2056a5'
																	: '#e3f2fd',
														}}>
														<div className='giftcard_voucher_title'>
															<h5
																style={{
																	color: isSelected.some(
																		(
																			selected,
																		) =>
																			selected.id ===
																				item.id &&
																			selected.status,
																	)
																		? 'white'
																		: '#000',
																}}>
																{item?.title}
															</h5>
														</div>
													</div>
													{isSelected.some(
														(selected) =>
															selected.id ===
																item.id &&
															selected.status,
													) ? (
														<span>
															<i className='fa-solid fa-circle-check'></i>
														</span>
													) : null}
												</div>
											))
									) : (
										<p>No gift cards found.</p>
									)}
								</div>
								<div
									className='row'
									style={{ paddingBottom: '20px' }}>
									<div className='col-sm-12  col-md-12 col-lg-12 col-xl-12'>
										<div
											className='button-section'
											style={{
												display: 'flex',
												justifyContent: 'flex-end',
											}}>
											<Link
												to='/admin/gift-card-update'
												state={{
													datas: isSelected,
													selectPurpose:
														selectPurpose,
												}}
												type='submit'
												className='btn btn-primary'>
												Update
											</Link>
										</div>
									</div>
								</div>
							</div>
							{showModal && (
								<CardViewModal
									show={showModal}
									close={() =>
										setState((prev) => ({
											...prev,
											showModal: false,
										}))
									}
									code={code}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default AllGiftCard;
